import React from "react";
import TableEmpresa from "./tableEmpresa";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import {
  checkAccess,
  ids,
  realCheckAccess,
} from "../../../../../helpers/rolAccess";
import { paths } from "../../../../../config/routes";

class Empresas extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root));
    }
  };

  render() {
    return (
      <div className="col-12 zero">
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <div className="col-12 zero">
            <TableEmpresa handleModal={this.handleModal} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Empresas);
